import React from 'react';
import clsx from 'clsx';

const Arrow = ({ colour }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" fill="none">
      <rect x="0.5" y="0.430664" width="40" height="40" rx="20" className={clsx({[`fill-${colour}`]:colour})}/>
      <path d="M16.5 9.43066L26.5 19.9307L16.5 30.4307" stroke="black" strokeWidth="3" strokeLinecap="round"/>
    </svg>
  )
}

export default Arrow
